module.exports = __webpack_public_path__ + "img/Pg-logo2.6ea508ed.png";